import { EdgeSystemStatus } from "./edgeUser";

export interface ValidationResult {
    displayName: boolean;
    vesselName: boolean;
    licenseNumber: boolean;
    email: boolean;
    rank: boolean;
    otp: boolean;
    password: boolean;
    userInfo: boolean;
    any: boolean;
};

export enum EdgeSystemType {
    None = 'None',
    DataSync = 'DataSync',
    LogSync = 'LogSync',
    CloudConnection = 'CloudConnection',
    CloudAuth = 'CloudAuth',
    ResetConfig = 'ResetConfig'
};

export interface EdgeSystemState {
    id: string;
    systemType: EdgeSystemType;
    status: EdgeSystemStatus;
    lastSuccessfulTimeUtc: string | null;
};

export type SystemState = {
    [key in EdgeSystemType]: EdgeSystemState
};
